export default "__VITE_ASSET__07e638f3__"